// Copied from https://k2-calculator-api.developer.azure-api.net/api-details#api=api-dev&operation=lookups
// When updating from the K2 API: flatten single-option nested dependencies (e.g. moduleHeightRange)
// rather than copying verbatim — there's no value in a dependency with only one possible value.
export const K2Lookup = {
  metadata: {
    configuration: {
      version: '1.1.3',
      supportedRegions: ['US'],
      supportedUnitSystems: ['imperial'],
      supportedMountingSolutions: ['CrossRail'],
    },
  },
  data: {
    US: {
      imperial: {
        k2OnRoof: {
          fields: {
            railType: {
              dependsOn: [],
              mapping: ['44-X', '44-X-Max', '48-X', '48-XL'],
            },
            railLength: {
              dependsOn: ['railType'],
              mapping: {
                '44-X': ['86', '172', '185'],
                '44-X-Max': ['172'],
                '48-X': ['172'],
                '48-XL': ['172'],
              },
            },
            railFinish: {
              dependsOn: ['railType', 'railLength'],
              mapping: {
                '44-X': {
                  '86': ['Mill'],
                  '172': ['Mill', 'Dark'],
                  '185': ['Mill', 'Dark'],
                },
                '44-X-Max': {
                  '172': ['Mill', 'Dark'],
                },
                '48-X': {
                  '172': ['Mill', 'Dark'],
                },
                '48-XL': {
                  '172': ['Mill', 'Dark'],
                },
              },
            },
            rails: {
              dependsOn: ['railType', 'railLength', 'railFinish'],
              mapping: {
                '44-X': {
                  '86': {
                    Mill: ['4000143'],
                  },
                  '172': {
                    Dark: ['4000720'],
                    Mill: ['4000719'],
                  },
                  '185': {
                    Dark: ['4000722'],
                    Mill: ['4000721'],
                  },
                },
                '44-X-Max': {
                  '172': {
                    Dark: ['4000820'],
                    Mill: ['4000819'],
                  },
                },
                '48-X': {
                  '172': {
                    Dark: ['4000724'],
                    Mill: ['4000723'],
                  },
                },
                '48-XL': {
                  '172': {
                    Dark: ['4000728'],
                    Mill: ['4000727'],
                  },
                },
              },
            },
            roofCovering: {
              dependsOn: [],
              mapping: ['comp', 'tile', 'standingseam', 'corrugated', 'trapezoidal', 'concrete'],
            },
            clampFinish: {
              dependsOn: ['moduleHeight'],
              mapping: {
                '30-45': ['Dark', 'Mill'],
              },
            },
            endClamp: {
              dependsOn: ['clampFinish'],
              mapping: {
                Dark: ['4000145', '4000050-B'],
                Mill: ['4000050-B', '4000135'],
              },
            },
            midClamps: {
              dependsOn: ['clampFinish', 'moduleHeight'],
              mapping: {
                Dark: {
                  moduleHeightRange: {
                    '30-45': ['4000145'],
                  },
                },
                Mill: {
                  moduleHeightRange: {
                    '30-45': ['4000135'],
                  },
                },
              },
            },
            attachments: {
              dependsOn: ['roofCovering', 'mountingOption'],
              mapping: {
                comp: {
                  rafter: [
                    '4000631',
                    '4000630',
                    '4000157',
                    '4000156',
                    '4000113',
                    '4000282',
                    '4000284',
                    '4000559',
                    '4000165',
                    '4000300',
                    'multimountPlusk2runnerMill',
                    'multimountPlusk2runnerDark',
                    '4000237',
                  ],
                  deck: [
                    '4000113',
                    '4000282',
                    '4000284',
                    '4000165',
                    '4000300',
                    'multimountPlusk2runnerMill',
                    'multimountPlusk2runnerDark',
                    '4000237',
                  ],
                },
                tile: {
                  rafter: [
                    '4000631',
                    '4000630',
                    '4000141-B',
                    '4000141',
                    '4000140',
                    '4000142',
                    '4000142-B',
                    '4000140-B',
                    '4001294',
                    '4000237',
                    '4000238',
                  ],
                  deck: [],
                },
                standingseam: {
                  rafter: [],
                  deck: ['4000016', '4000017'],
                },
                corrugated: {
                  rafter: ['4000631', '4000630'],
                  deck: ['4000631', '4000630', '4000307'],
                },
                trapezoidal: {
                  rafter: ['4000631', '4000630'],
                  deck: ['4000631', '4000630', '4000308'],
                },
                concrete: {
                  rafter: ['4000631', '4000630', '4000080', '4000218', '4000559'],
                  deck: ['4000631', '4000630', '4000080', '4000218', '4000559'],
                },
              },
            },
            fasteners: {
              dependsOn: ['roofCovering', 'mountingOption', 'attachments'],
              mapping: {
                comp: {
                  rafter: {
                    '4000237': ['4000310'],
                    '4000282': ['4000170', '4000310'],
                    '4000284': ['4000170', '4000310'],
                    '4000630': ['4000170', '4000359', '4000358', '4000260', 'ThirdPartyAttachment'],
                    '4000631': ['4000170', '4000359', '4000358', '4000260', 'ThirdPartyAttachment'],
                    multimountPlusk2runnerMill: ['4000170', '4000310'],
                    multimountPlusk2runnerDark: ['4000170', '4000310'],
                  },
                  deck: {
                    '4000237': ['4000310'],
                  },
                },
                tile: {
                  rafter: {
                    '4000237': ['4000310'],
                    '4000238': ['4000310'],
                    '4000630': ['4000170', '4000359', '4000358', '4000260', 'ThirdPartyAttachment'],
                    '4000631': ['4000170', '4000359', '4000358', '4000260', 'ThirdPartyAttachment'],
                  },
                  deck: {},
                },
                standingseam: {
                  rafter: {},
                  deck: {},
                },
                corrugated: {
                  rafter: {
                    '4000630': ['4000149', '4000167'],
                    '4000631': ['4000149', '4000167'],
                  },
                  deck: {},
                },
                trapezoidal: {
                  rafter: {
                    '4000630': ['4000149', '4000167'],
                    '4000631': ['4000149', '4000167'],
                  },
                  deck: {},
                },
                concrete: {
                  rafter: {
                    '4000630': ['4000170', '4000359', '4000358', '4000260', 'ThirdPartyAttachment'],
                    '4000631': ['4000170', '4000359', '4000358', '4000260', 'ThirdPartyAttachment'],
                  },
                  deck: {
                    '4000630': ['4000170', '4000359', '4000358', '4000260', 'ThirdPartyAttachment'],
                    '4000631': ['4000170', '4000359', '4000358', '4000260', 'ThirdPartyAttachment'],
                  },
                },
              },
            },
            connectors: {
              dependsOn: ['railType', 'railFinish'],
              mapping: {
                '80': {
                  Mill: ['4001196'],
                },
                '44-X': {
                  Dark: ['4000052-T'],
                  Mill: ['4000051-T'],
                },
                '44-x-Max': {
                  Dark: ['4000052-T'],
                  Mill: ['4000051-T'],
                },
                '48-X': {
                  Dark: ['4000386'],
                  Mill: ['4000385'],
                },
                '48-XL': {
                  Dark: ['4000386'],
                  Mill: ['4000385'],
                },
              },
            },
            everestLugs: {
              dependsOn: ['railFinish'],
              mapping: {
                Mill: ['4000006-H'],
                Dark: ['4000006-H'],
              },
            },
          },
        },
        k2SimpleTilt: {
          fields: {
            railType: {
              dependsOn: [],
              mapping: ['44-X', '44-X-Max', '48-X', '48-XL'],
            },
            railLength: {
              dependsOn: ['railType'],
              mapping: {
                '44-X': ['86', '172', '185'],
                '44-X-Max': ['172'],
                '48-X': ['172'],
                '48-XL': ['172'],
              },
            },
            railFinish: {
              dependsOn: ['railType', 'railLength'],
              mapping: {
                '44-X': {
                  '86': ['Mill', 'Dark'],
                  '172': ['Mill', 'Dark'],
                  '185': ['Mill', 'Dark'],
                },
                '44-X-Max': {
                  '172': ['Mill', 'Dark'],
                },
                '48-X': {
                  '172': ['Mill', 'Dark'],
                },
                '48-XL': {
                  '172': ['Mill', 'Dark'],
                },
              },
            },
            rails: {
              dependsOn: ['railType', 'railLength', 'railFinish'],
              mapping: {
                '44-X': {
                  '86': {
                    Dark: ['4000144'],
                    Mill: ['4000143'],
                  },
                  '172': {
                    Dark: ['4000720'],
                    Mill: ['4000719'],
                  },
                  '185': {
                    Dark: ['4000722'],
                    Mill: ['4000721'],
                  },
                },
                '44-X-Max': {
                  '172': {
                    Dark: ['4000820'],
                    Mill: ['4000819'],
                  },
                },
                '48-X': {
                  '172': {
                    Dark: ['4000724'],
                    Mill: ['4000723'],
                  },
                },
                '48-XL': {
                  '172': {
                    Dark: ['4000728'],
                    Mill: ['4000727'],
                  },
                },
              },
            },
            // K2 lookups v1.1.3 also lists membrane, epdm, rolledAsphalt, tpo as roof coverings,
            // but the SimpleTilt BOM endpoint only accepts material: 'concrete'. Omitted until K2 supports them.
            roofCovering: {
              dependsOn: [],
              mapping: ['concrete'],
            },
            clampFinish: {
              dependsOn: ['moduleHeight'],
              mapping: {
                '30-45': ['Dark', 'Mill'],
              },
            },
            endClamp: {
              dependsOn: ['clampFinish'],
              mapping: {
                Dark: ['4000145', '4000050-B'],
                Mill: ['4000050-B', '4000135'],
              },
            },
            midClamps: {
              dependsOn: ['clampFinish'],
              mapping: {
                Dark: ['4000145'],
                Mill: ['4000135'],
              },
            },
            attachments: {
              dependsOn: ['roofCovering'],
              mapping: {
                concrete: ['4000218', '4000284', '4000631', '4000630', '4000282'],
              },
            },
            fasteners: {
              dependsOn: ['roofCovering', 'attachments'],
              mapping: {
                concrete: {
                  '4000630': ['ThirdPartyAttachment'],
                  '4000631': ['ThirdPartyAttachment'],
                },
              },
            },
            connectors: {
              dependsOn: ['railType', 'railFinish'],
              mapping: {
                '44-X': {
                  Dark: ['4000052-T'],
                  Mill: ['4000051-T'],
                },
                '44-X-Max': {
                  Dark: ['4000052-T'],
                  Mill: ['4000051-T'],
                },
                '48-X': {
                  Dark: ['4000386'],
                  Mill: ['4000385'],
                },
                '48-XL': {
                  Dark: ['4000386'],
                  Mill: ['4000385'],
                },
              },
            },
            everestLugs: {
              dependsOn: ['railFinish'],
              mapping: {
                Mill: ['4000006-H'],
                Dark: ['4000006-H'],
              },
            },
          },
        },
      },
    },
  },
}
